import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import eq from 'webapp/helpers/eq';
import BoardImagePreviewComponent from 'webapp/components/board/image-preview';

import type Report from 'webapp/models-custom/report';
import type ReportSlide from 'webapp/models-custom/report-slide';

interface Args {
	model?: Report | null;
	selectedSlide: ReportSlide;
	onOpenSlide: (slide: ReportSlide) => void;
}

export default class ReportsViewerNavigationComponent extends Component<Args> {
	@action
	openSlide(slide: ReportSlide): void {
		this.args.onOpenSlide(slide);
	}
	<template>
		<div class="report_nav">

			<ol>
				{{#each @model.sortedSlides as |slide|}}
					<li class={{if (eq slide @selectedSlide) "selected"}}>
						<a class="open" {{on "click" (fn this.openSlide slide)}}>
							<BoardImagePreviewComponent
								@image={{slide.shownImage}}
								@fallbackImage={{slide.fallbackImage}}
								@color={{slide.shownColor}}
							/>
						</a>
					</li>
				{{/each}}
			</ol>

		</div>
	</template>
}
